module.exports = __webpack_public_path__ + "static/media/Athletics.4722c9d0.jpg";